import { sanitizeQtyInput, handleQtyKeyDown } from '../../util/sanitizeQtyInput';
import * as S from './styles'

const IncrementStepper = ({ qty, setQty, isProductCard, styleQtd }) => {
  const handleQtyCount = (type) => {
    const currentQty = Number(qty) || 0
    if (type === 'increase') {
      setQty(currentQty + 1);
    } else if (type === 'decrease' && currentQty > 0) {
      setQty(Math.max(0, currentQty - 1))
    }
  };

  const handleQtyChange = (e) => {
    const replacedValue = sanitizeQtyInput(e.target.value);
    const formattedValue = parseFloat(replacedValue);
    setQty(Number.isFinite(formattedValue) && formattedValue >= 0 ? formattedValue : 0);
  };

  const handleInputChange = (e) => {
    setQty(sanitizeQtyInput(e.target.value));
  }

  return (
    <S.IncrementStepper $isProductCard={isProductCard} $styleQtd={styleQtd}>
      <S.IncrementStepperBtn onClick={() => handleQtyCount('decrease')} $isProductCard={isProductCard}>-</S.IncrementStepperBtn>
      <S.IncrementStepperInput 
        type='number'
        value={qty} 
        onChange={handleInputChange} 
        onKeyDown={handleQtyKeyDown}
        onBlur={handleQtyChange}
        $styleQtd={styleQtd}
        $isProductCard={isProductCard}/>
      {/* <S.IncrementStepperValue>{qty}</S.IncrementStepperValue> */}
      <S.IncrementStepperBtn onClick={() => handleQtyCount('increase')} $isProductCard={isProductCard}>+</S.IncrementStepperBtn>
    </S.IncrementStepper>

  )
}

export default IncrementStepper
